<template>
  <!-- <v-card>
    <v-container fluid>
      <v-layout row wrap align-center justify-center fill-height>
        <v-flex xl6 lg6 md6 sm6 hidden-xs-only>
          <v-btn style="margin:0px" flat icon color="primary" v-on:click="refresh">
            <v-icon>cached</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xl6 lg6 md6 sm6 xs12 text-lg-right>
          <v-text-field
            style="padding:0px; margin:0px"
            id="searchBox"
            single-line
            v-model="searchValue"
            @keydown.enter="enter"
            placeholder="Buscar"
            append-icon="search"
            light
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-text style="padding-top:0px">
      <v-data-table
        flat
        v-bind:pagination.sync="pagination"
        item-key="id"
        v-model="selected"
        :items="commissionsPreliquidation"
        :headers="headers"
        class="v-table-list theme--light"
        :rows-per-page-text="$t('message.rowsByPage')"
      >
        <template slot="headers" scope="props">
          <tr class="border-buttom">
            <th width="1%" class="column">
              <v-checkbox
                style="display:none"
                primary
                hide-details
                @click.native="toggleAll"
                :input-value="props.all"
                :indeterminate="props.indeterminate"
              ></v-checkbox>
            </th>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column sortable text-xs-left', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              {{ header.text }}
              <v-icon>arrow_upward</v-icon>
            </th>
          </tr>
        </template>
        <template slot="items" scope="props">
          <tr :active="props.selected" @click="props.selected = !props.selected">
            <td width="1%">
              <v-checkbox
                hide-details
                v-model="selectRow[props.index]"
                @change="uniqueCheck(props.item.number, props.index)"
              ></v-checkbox>
                </td>
            <td class="text-xs-left cut-text">{{ props.item.creationDate }}</td>
            <td class="text-xs-left cut-text">{{ props.item.number }}</td>
            <td class="text-xs-left cut-text">{{ props.item.vtAgency }}</td>
            <td class="text-xs-left cut-text">{{ props.item.apsCode }}</td>
            <td class="text-xs-left cut-text">{{ props.item.totalInvoiceVisualice | currency }}</td>
            <td class="text-xs-left cut-text">{{ props.item.status }}</td>
          </tr>
        </template>
        <template slot="no-data">
          <div>{{$t('message.noPreliquidations')}}</div>
        </template>
        <template
          slot="pageText"
          slot-scope="props"
        >{{ props.pageStart }} - {{ props.pageStop }} {{$t('message.of')}} {{ props.itemsLength }}</template>
      </v-data-table>
    </v-card-text>
  </v-card> -->
   <v-card>
    <v-container fluid>
      <v-layout row wrap align-center justify-center fill-height>
        <v-flex xl6 lg6 md6 sm6 hidden-xs-only>
          <v-btn flat icon color="primary" v-on:click="refresh">
            <v-icon>cached</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xl6 lg6 md6 sm6 xs12 text-lg-right>
          <v-text-field
            style="padding:0px; margin:0px"
            id="searchBox"
            single-line
            v-model="searchValue"
            @keydown.enter="enter"
            placeholder="Buscar"
            append-icon="search"
            light
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider style="margin:0px"></v-divider>
      <v-card-text style="padding-top:0px">
      <v-data-table
      flat
        v-bind:pagination.sync="pagination"
        item-key="id"
        :rows-per-page-text="$t('message.rowsByPage')"
         :items="commissionsPreliquidation"
        :headers="headers"
        class="v-table-list theme--light"
        v-model="selected"
        :custom-sort="customSort"
      >
         <template slot="items" scope="props">
          <tr :active="props.selected" @click="props.selected = !props.selected">
            <td width="1%">
              <v-checkbox
                hide-details
                v-model="selectRow[props.index]"
                @change="uniqueCheck(props.item.number, props.index)"
              ></v-checkbox>
              </td>
            <td class="text-xs-left cut-text">{{ moment(props.item.creationDate,"DD/MM/YYYY  HH:mm").format('DD/MM/YYYY  HH:mm') }}</td>
            <td class="text-xs-left cut-text">{{ props.item.number }}</td>
            <td class="text-xs-left cut-text"> {{ props.item.vtAgency === '0' ? 'Todas' : props.item.vtAgency }}</td>
            <td class="text-xs-left cut-text">{{ props.item.apsCode }}</td>
            <td class="text-xs-left cut-text">{{ props.item.printedTotal | currency }}</td>
            <td class="text-xs-left cut-text">{{ props.item.status }}</td>
            <td class="text-xs-left cut-text">{{ props.item.massive }}</td>
          </tr>
        </template>
        
        <template slot="no-data">
          <div>{{$t('message.noPreliquidations')}}</div>
        </template>
        <template
          slot="pageText"
          slot-scope="props"
        >{{ props.pageStart }} - {{ props.pageStop }} {{$t('message.of')}} {{ props.itemsLength }}</template>
      </v-data-table>
    </v-card-text>
    </v-card>
</template>


<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";
import router from "@/router";

export default {
  computed: {
    ...mapGetters(["loadingCommission", "commissionsPreliquidation", "agency"])
  },
  mounted() {
    this.$store.dispatch("getCommissionsPreliquidation");
  },
  methods: {
    nzDate: nzDate,
    uniqueCheck(e, index) {
      let select = this.selectRow[index];
      for (let i = 0; i < this.selectRow.length; i++) {
        if (index != i) {
          this.selectRow[i] = false;
        }
      }
      if (!this.selectRow[index]) {
        this.selectedValue = null;
      } else {
        this.selectedValue = e;
      }
    },
    toggleAll() {
      if (this.selected.length) {
        this.selected = [];
      } else {
        this.selected = this.commissionsPreliquidation.slice();
      }
      this.$store.dispatch("updateCommissionSelected", this.selected);
    },
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (index === "creationDate") {
            
            let dateA= new Date(this.getDate(a[index]))
            let dateB= new Date(this.getDate(b[index]))
            /* let demoInvalidDate=new Date(a[index])
            if(demoInvalidDate=='Invalid Date'){
              var formattedA = moment(a[index]).format('D MMMM YYYY');
              //var formattedB = moment(demoInvalidDate).format('D MMMM YYYY');
              console.log(a[index],formattedA)
           
            } */
          if (!isDesc) {
            return dateA < dateB ? -1 : 1;
          } else {
            return dateB < dateA ? -1 : 1;
          }
        } else {
          if (!isDesc) {
            return a[index] < b[index] ? -1 : 1;
          } else {
            return b[index] < a[index] ? -1 : 1;
          }
        }
      });
      return items;
    },
    getDate(d)
    {
        var day, month, year;

        let result = String(d).match("[0-9]{2}([\-/ \.])[0-9]{2}[\-/ \.][0-9]{4}");
        if(null != result) {
            let dateSplitted = result[0].split(result[1]);
            day = dateSplitted[0];
            month = dateSplitted[1];
            year = dateSplitted[2];
        }
        result = String(d).match("[0-9]{4}([\-/ \.])[0-9]{2}[\-/ \.][0-9]{2}");
        if(null != result) {
            let dateSplitted = result[0].split(result[1]);
            day = dateSplitted[2];
            month = dateSplitted[1];
            year = dateSplitted[0];
        }

        if(month>12) {
            let aux = day;
            day = month;
            month = aux;
        }

        return year+"/"+month+"/"+day;
    },
    changeSort(column) {
      this.selectedValue = null;
       this.selectRow= [],
      this.additionalGrouped = [];
      if (this.pagination.sortBy === column) {
        this.additionalGrouped[0] = this.selectedValue;
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
        this.additionalGrouped[0] = this.selectedValue;
      }
    },
    refresh() {
      this.$store.dispatch("getCommissionsPreliquidation").then(() => {
        for (let i = 0; i < this.selectRow.length; i++) {
          this.selectRow[i] = false;
        }
        this.selectedValue = null;
        this.additionalGrouped = [];
      });
    },
    enter() {
      this.$store.dispatch("getCommissionsPreliquidation", this.searchValue);
    }
  },
  watch: {
    loadingCommission(val) {
      if (val) {
        this.$root.$emit("showLoading", "Cargando información, por favor espere...");
      } else {
        this.$root.$emit("hideLoading");
      }
    },
    agency(val) {
      this.$store.dispatch("getCommissionsPreliquidation");
    }
  },
  data() {
    return {
      selectRow: [],
      selectedValue: null,
      additionalGrouped: [],
      searchValue: "",
      matches: [],
      pagination: {
        sortBy: "creationDate"
      },
      selected: [],
      headers: [
        {
          align: "left",
          sortable: false,
          text: "",
          value: "",
          width: "1%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.date"),
          value: "creationDate",
          width: "15.18%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.bill"),
          value: "number",
          width: "15.18%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.branch"),
          value: "vtAgency",
          width: "15.18%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.agent"),
          value: "apsCode",
          width: "15.18%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.toPay"),
          value: "totalInvoiceVisualice",
          width: "15.18%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.status"),
          value: "status",
          width: "15.18%"
        },
        {
          align: "left",
          sortable: true,
          text: "Es Masivo",
          value: "massive",
          width: "16.0%"
        }
      ]
    };
  }
};
</script>